import CityPageTemplate from "../city-template/CityPageTemplate";
import { rochesterMnConfig } from "./data";

export default function RochesterPage() {
  return <CityPageTemplate config={rochesterMnConfig} />;
}